import React, { useContext, useEffect, useState,useRef } from "react";
import { observer } from "mobx-react";
import Form from 'react-bootstrap/Form';
import Skeleton from 'react-loading-skeleton'
import { StyledDropZone } from 'react-drop-zone'
import { useTranslation, Trans } from "react-i18next";
import { FileUploader } from "react-drag-drop-files";
import styled, { css } from 'styled-components';
import Stack from 'react-bootstrap/Stack';
import { toast } from "react-toastify";
import { truncateString } from "./../../utils";

const FormFileUpload = (props) => {
    const { t, i18n } = useTranslation();

    const fileInputRef = useRef();
    const [filename, setFilename] = useState("");   
    const [files, setFiles] = useState(null);

    const parseFiles = (file) => {

        const dataTransfer = new DataTransfer()
        if (file?.length > 0) {
            Array.from(file)?.forEach(f => {
                dataTransfer.items.add(f)
            })
        } else {
            if (file) { dataTransfer.items.add(file) }
        }
        return dataTransfer.files;
    }

    const handleChange = (file) => {
        if (props.disabled) {            
            return;
        }

        var files = parseFiles(file);
            
        if (fileInputRef && fileInputRef.current) {
            fileInputRef.current.files = files;
        }

        setFiles(files)
        props.onFileSelected?.(files);               
    };

    return (
        <div className="file-upload">
        <Form.Group controlId={props.id}>
                       
                {props.isLoading ? <Skeleton /> :(props.compact? <span/>: <Form.Label>{props.label}</Form.Label>)}
                {(files?.length > 0 && !(props?.base64)) && !props.compact && 
                    <span>&nbsp;&nbsp;
                        <Form.Text className="text-right" onClick={() => {                            
                            handleChange(null);
                        }} style={{ cursor: "pointer" }}>
                            (Clear)
                        </Form.Text>
                    </span>
                }

                {props.isLoading ? <Skeleton height={100} /> : <FileUploader
                    disabled={(props.disabled || props.isUploading) ?? false}
                    onTypeError={()=>toast.error(t("filetypeNotValid"))}
                    classes="drop_area"
                    hoverTitle={t("dragAndDropHere")}
                    
                    children={
                        <>
                            {props.compact ?

                                <div title={t("dragAndDropHere")} style={{ backgroundColor: props.disabled ? "lightgray" : "white", borderWidth: 2, height: "35px", textAlign: "center", borderStyle: "dashed", width: "150px", alignItems: "center", display: "flex" }}>
                                    <div style={{ height: "35px", width: "150px", fontSize: "12px", padding: props.label?.length ? '8px 8px' : '8px 0px', }}>{
                                        props.label?.length ?
                                            <div style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}  title={props.label ?? null}>{truncateString(props.label, 30)}</div>
                                            : <div>{t("dragDropDocuments")}</div>
                                    }</div>
                                </div>

                                :
                                <div style={{ borderWidth: 2, height: "100px", textAlign: "center", borderStyle: "dashed", width: "100%", alignItems: "center", display: "flex" }}>
                                    {props?.base64 ? <img width="100%" height="100%" src={`data:image/jpg;base64,${props.base64}`} alt="missing" style={{ objectFit: "contain" }} /> :
                                        <div style={{ height: "100px", width: "100%", fontSize: "12px", padding: 8, overflowY: "auto" }}>{
                                            files?.length > 0 ?
                                                Array.from(files)?.map((x, i) => <div key={i}>{x.name}<br /></div>)
                                                : <div>{t("dragDropDocuments")} ({props.accept})</div>
                                        }</div>
                                    }
                                </div>
                            }
                        </>
                    }
                    dropMessageStyle={{
                        backgroundColor: 'rgba(0,0,0,1)', color: "white", display:props.hideHover?"none":"inital"
                    }}
                    multiple={props.multiple ?? false}
                    handleChange={handleChange}
                    types={props.accept?.split(",").map(x => x.replace(".", "")) ?? []}
                />}
                <Form.Control required={props.required} style={{ display: "none" }} multiple={props.multiple ?? false} name={props.id} ref={fileInputRef} type="file" onChange={(e) => { props.onFileSelected?.(e.target.files); setFilename(e.target.files[0]?.name) }} accept={props.accept ?? null} />
            <Form.Control.Feedback type="invalid">
                {t('fieldRequired')}
            </Form.Control.Feedback>
            </Form.Group>
        </div>
    );
};

export default observer(FormFileUpload);
